export default function Testimonials() {
  const testimonials = [
    {
      name: 'Dr. Margaret Chen',
      handle: 'University Archives',
      avatar: 'https://public.readdy.ai/ai/img_res/0cb0290315e29fe48371cdab32f938ee.jpg',
      text: 'The digitization of our 50-year microfilm collection was handled with exceptional care and precision. The team\'s expertise in handling fragile materials and delivering high-resolution scans exceeded our expectations. Our historical records are now accessible to researchers worldwide.',
      rating: 5
    },
    {
      name: 'Robert Thompson',
      handle: 'Heritage Foundation',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Caucasian%20man%20in%20business%20attire%20with%20warm%20smile%20and%20confident%20demeanor%2C%20headshot%20portrait%20with%20soft%20office%20lighting%20and%20neutral%20clean%20background%2C%20emphasizing%20experienced%20heritage%20preservation%20professional%20and%20archival%20consultant&width=200&height=200&seq=avatar-2&orientation=squarish',
      text: 'Outstanding service from start to finish. They transformed our bound historical documents into searchable digital archives while preserving every detail. The OCR accuracy was remarkable, making our entire collection keyword-searchable.',
      rating: 5
    },
    {
      name: 'Linda Martinez',
      handle: 'County Records Office',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Hispanic%20woman%20records%20manager%20with%20friendly%20expression%20in%20office%20environment%2C%20headshot%20portrait%20with%20soft%20professional%20lighting%20and%20clean%20minimal%20background%2C%20emphasizing%20experienced%20government%20archival%20specialist%20and%20digitization%20expert&width=200&height=200&seq=avatar-3&orientation=squarish',
      text: 'We had decades of microfiche that needed converting. The team provided a comprehensive plan, met every deadline, and the digital output quality was exceptional. Their project management made the entire process seamless.',
      rating: 5
    },
    {
      name: 'James Wilson',
      handle: 'Corporate Archives',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20African%20American%20man%20corporate%20archivist%20with%20confident%20smile%20in%20business%20setting%2C%20headshot%20portrait%20with%20professional%20studio%20lighting%20and%20neutral%20clean%20background%2C%20emphasizing%20experienced%20business%20preservation%20expert%20and%20digitization%20consultant&width=200&height=200&seq=avatar-4&orientation=squarish',
      text: 'Their expertise in legacy media preservation is unmatched. They successfully digitized our company\'s historical photographs, slides, and film negatives dating back to the 1940s. The color restoration work was absolutely stunning.',
      rating: 5
    },
    {
      name: 'Sarah Anderson',
      handle: 'Medical Research Institute',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Caucasian%20woman%20medical%20researcher%20with%20warm%20professional%20demeanor%20in%20laboratory%20coat%2C%20headshot%20portrait%20with%20soft%20natural%20lighting%20and%20clean%20clinical%20background%2C%20emphasizing%20trustworthy%20scientific%20archival%20specialist%20and%20digitization%20expert&width=200&height=200&seq=avatar-5&orientation=squarish',
      text: 'Converting our medical research archives was critical for our ongoing studies. The team handled sensitive materials with the utmost care and delivered perfectly organized digital files with comprehensive metadata. Highly recommended!',
      rating: 5
    },
    {
      name: 'Michael O\'Brien',
      handle: 'Public Library System',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Caucasian%20man%20librarian%20with%20friendly%20approachable%20expression%20in%20library%20setting%2C%20headshot%20portrait%20with%20warm%20ambient%20lighting%20and%20clean%20professional%20background%2C%20emphasizing%20experienced%20library%20preservation%20specialist%20and%20archival%20digitization%20expert&width=200&height=200&seq=avatar-6&orientation=squarish',
      text: 'The group workshop program was invaluable for our staff. We learned best practices for in-house digitization projects and received expert guidance on equipment selection. The hands-on training was exceptionally thorough.',
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-24 px-6 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto">
        <div className="mb-4">
          <span className="px-5 py-2 rounded-full bg-[#0D9488]/10 text-[#0D9488] text-sm font-semibold inline-block whitespace-nowrap">
            CLIENT SUCCESS STORIES
          </span>
        </div>

        <h2 className="text-5xl md:text-6xl font-bold text-black mb-16 leading-tight max-w-3xl">
          Trusted by Organizations
          <br />
          Preserving History
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300"
              style={{ 
                gridRow: index === 1 || index === 4 ? 'span 1' : 'auto'
              }}
            >
              <div className="flex items-start gap-4 mb-6">
                <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0">
                  <img 
                    src={testimonial.avatar} 
                    alt={testimonial.name} 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-bold text-[#1E3A8A] text-base">{testimonial.name}</h4>
                  <p className="text-gray-500 text-sm">@{testimonial.handle.replace(/\s+/g, '')}</p>
                </div>
              </div>

              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#D97706] text-lg"></i>
                ))}
              </div>

              <p className="text-gray-700 text-sm leading-relaxed">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 text-base mb-6">
            Join hundreds of satisfied clients who have trusted us with their precious archives
          </p>
          <div className="flex flex-wrap justify-center gap-8 items-center opacity-60">
            <div className="text-gray-400 font-semibold text-sm">500+ Projects Completed</div>
            <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
            <div className="text-gray-400 font-semibold text-sm">2M+ Documents Digitized</div>
            <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
            <div className="text-gray-400 font-semibold text-sm">98% Client Satisfaction</div>
          </div>
        </div>
      </div>
    </section>
  );
}
